import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-customer-service-service-hub-details/src/ui/__generated__/ServiceHubDetailsPageQuery$parameters';
import { fg } from '@atlassian/jira-feature-gating';

export const helpCenterSettingDetailsAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-help-center-setting-details-app" */ './src/ui'),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			serviceHubDetailsQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					isCsmOnboardingEnabled: fg('csm-onboarding'),
				},
				options: {
					fetchPolicy: fg('csm-onboarding')
						? ('store-and-network' as const)
						: ('store-or-network' as const),
				},
			},
		},
	}),
});
